module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAABHNCSVQICAgIfAhkiAAAAQFJREFUaEPtl9ENwjAMRK8bwCQwAmxUJoGNYASYBEaoLAUJCZE4uVgo6vWnH7XT+N4p104Y/JoG3z80wL8JioAIkArIQqSAdLsI0BKSC4hAQcBNev4ihf7ZHknANv9Mb94CCBkicoADgGsa4AjgFkFBA2RUFQGP5WQhWcjjk0zNai1kIbUriLcHcEk1M4B7of7REnYtBD4TljTAV3t1Yq9yAJPNKJhFcpc9P6eCk8NCZrHq76UWAl7bKIk9SomAktjjEyVxm0o6hTy6RZ5Cw//UvxPb7tUJ61HfaiIJePdA1WkASr4OzSLQQURqCRGg5OvQLAIdRKSWEAFKvg7NwxNYABJVMjEDodyDAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/add_district_icon.png
// module id = 3Kj4
// module chunks = 3